import React from 'react';
import ReadyForInvoicingTpJobItem from './ReadyForInvoicingTpJobItem';
import TpJobItem from './TpJobItem';
import InvoiceAutomationStatusChip from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationStatusChip.tsx';

export default class ClientReadyForInvoicingTpJobItem extends ReadyForInvoicingTpJobItem {
  static FieldsToShowInDataTable() {
    const fields = ReadyForInvoicingTpJobItem.FieldsToShowInDataTable();
    const sourceIndex = fields.findIndex((f) => f.orderById === 'ThirdPartySource');
    fields.splice(
      sourceIndex + 1,
      0,
      {
        label: 'Project',
        orderById: 'ProjectNameAndId',
        data: TpJobItem.getProjectCellContent,
        minWidth: 150,
      },
      // The list mixes the client's projects, so each row says whether its project is invoiced automatically, also
      // when that is by another project's setup.
      {
        label: 'Automatic Invoicing',
        orderById: '',
        data: (item) => (
          <InvoiceAutomationStatusChip
            isActive={item.ProjectInvoiceAutomationIsActive}
            runSchedule={item.ProjectInvoiceAutomationRunSchedule}
            invoicedWithProjectId={item.ProjectInvoiceAutomationInvoicedWithProjectId}
            invoicedWithProjectName={item.ProjectInvoiceAutomationInvoicedWithProjectName}
          />
        ),
      }
    );
    return fields;
  }
}
